import { Controller } from '@hotwired/stimulus'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { AvatarUploader } from '../components/AvatarUploader'

// Connects to data-controller="avatar-uploader"
export default class extends Controller {
  static values = {
    initialUrl: String,
  }
  static targets = ['input', 'remove']

  connect() {
    this.renderComponent()
  }

  disconnect() {
    if (this.root) {
      this.root.unmount()
    }
  }

  renderComponent() {
    // Create a container for the React component if it doesn't exist
    let container = this.element.querySelector('.react-root')
    if (!container) {
      container = document.createElement('div')
      container.classList.add('react-root')
      this.element.appendChild(container)
      // Hide the original Rails inputs but keep them in DOM for form submission
      // We'll manage them via the React component callbacks
      this.inputTarget.style.display = 'none'
    }

    if (!this.root) {
      this.root = createRoot(container)
    }

    this.root.render(
      React.createElement(AvatarUploader, {
        currentAvatarUrl: this.initialUrlValue || null,
        onFileChange: this.handleFileChange.bind(this),
        onRemove: this.handleRemove.bind(this),
      }),
    )
  }

  handleFileChange(file) {
    // Create a DataTransfer to set the files property of the input
    const dataTransfer = new DataTransfer()
    dataTransfer.items.add(file)
    this.inputTarget.files = dataTransfer.files
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))

    // Ensure the remove checkbox is unchecked if we are adding a file
    if (this.hasRemoveTarget) {
      this.removeTarget.checked = false
    }
  }

  handleRemove() {
    // Clear the file input
    this.inputTarget.value = ''

    // Check the remove checkbox so Rails knows to delete the attachment
    if (this.hasRemoveTarget) {
      this.removeTarget.checked = true
    }
  }
}
